import React from 'react';

/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
const PartnerPortalConfig = {
	settings: {
		layout: {
			config: {
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	routes: [
		{
			path: '/partner/jobs/:jobId/view',
			component: React.lazy(() => import('./jobs/PartnerJobView'))
		},
		{
			path: '/partner/jobs/:jobId/apply',
			component: React.lazy(() => import('./apply/PartnerApply'))
		},
		{
			path: '/partner/jobs',
			exact: true,
			component: React.lazy(() => import('./jobs/PartnerJobs'))
		}
	]
};

export default PartnerPortalConfig;
/* Code end. Harsha using AI Agent. October 7, 2026 */
